/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const resourcePatchRequestSchema = z.object({
  employmentType: z.enum(['EMPLOYEE', 'CONTRACTOR', 'PARTNER', 'ON_DEMAND']).nullish(),
  name: z.string().nullish(),
  type: z.enum(['RESOURCE', 'PLACEHOLDER']).nullish(),
  workforceCategory: z.enum(['EMPLOYEE', 'CONTRACTOR', 'VENDOR', 'FREELANCER']).nullish(),
});
